import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
  fade,
  Divider,
  Hidden,
} from '@material-ui/core';
import SecurityIcon from '@material-ui/icons/Security';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import GetStartedBtn from 'components/ListYourBike/GetStartedBtn';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginTop: theme.spacing(13),
    marginBottom: theme.spacing(13),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(22),
      marginTop: theme.spacing(18),
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(5.5),
      marginBottom: theme.spacing(5.5),
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    marginBottom: theme.spacing(5),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(8),
      textAlign: 'left',
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'center',
      marginBottom: theme.spacing(11.25),
    },
  },
  partContainer: {
    padding: theme.spacing(0, 0, 4.5),
    [theme.breakpoints.only('sm')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.only('md')]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.up('lg')]: {
      height: '100%',
      borderRadius: 30,
      border: `1px solid ${theme.palette.grey[200]}`,
      padding: theme.spacing(7.75, 3.5),
    },
  },
  partIcn: {
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
    borderRadius: 15,
    boxShadow: `0 0 4px 0 ${fade(theme.palette.common.black, 0.15)}`,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
    marginBottom: theme.spacing(5.25),
    [theme.breakpoints.only('sm')]: {
      width: theme.spacing(4.5),
      height: theme.spacing(4.5),
      borderRadius: 5,
      margin: 'auto',
      marginBottom: theme.spacing(2),
    },
    '& .MuiSvgIcon-root': {
      width: theme.spacing(4.5),
      height: theme.spacing(4.5),
      color: theme.palette.common.white,
      [theme.breakpoints.only('sm')]: {
        width: theme.spacing(2.75),
        height: theme.spacing(2.75),
      },
    },
  },
  partTitle: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: '500',
    [theme.breakpoints.only('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  partDesc: {
    letterSpacing: theme.typography.pxToRem(0.5),
    lineHeight: theme.typography.pxToRem(24),
    marginTop: theme.spacing(1.5),
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.only('md')]: {
      width: '85%',
    },
  },
  getStartedBox: {
    marginTop: theme.spacing(9),
    textAlign: 'center',
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(4.5),
    },
  },
  divider: {
    marginTop: theme.spacing(10),
    backgroundColor: theme.palette.grey[200],
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(5.5),
    },
  },
}));

const GotYourBack = ({ i18n }) => {
  const classes = useStyles();

  const partsIcn = [
    <SecurityIcon />,
    <VerifiedUserIcon />,
    <HeadsetMicIcon />,
    <StarHalfIcon />,
  ];

  return (
    <>
      <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
        <Typography variant="h2" classes={{ root: classes.title }}>
          {i18n('fe_es_got_your_back:title')}
        </Typography>

        <Grid container alignItems="stretch" spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <Box className={classes.partContainer}>
              <Box className={classes.partIcn}>{partsIcn[0]}</Box>
              <Typography variant="h4" classes={{ root: classes.partTitle }}>
                {i18n('fe_es_got_your_back:parts.title1')}
              </Typography>
              <Typography classes={{ root: classes.partDesc }}>
                {i18n('fe_es_got_your_back:parts.desc1')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Box className={classes.partContainer}>
              <Box className={classes.partIcn}>{partsIcn[1]}</Box>
              <Typography variant="h4" classes={{ root: classes.partTitle }}>
                {i18n('fe_es_got_your_back:parts.title2')}
              </Typography>
              <Typography classes={{ root: classes.partDesc }}>
                {i18n('fe_es_got_your_back:parts.desc2')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Box className={classes.partContainer}>
              <Box className={classes.partIcn}>{partsIcn[2]}</Box>
              <Typography variant="h4" classes={{ root: classes.partTitle }}>
                {i18n('fe_es_got_your_back:parts.title3')}
              </Typography>
              <Typography classes={{ root: classes.partDesc }}>
                {i18n('fe_es_got_your_back:parts.desc3')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Box className={classes.partContainer}>
              <Box className={classes.partIcn}>{partsIcn[3]}</Box>
              <Typography variant="h4" classes={{ root: classes.partTitle }}>
                {i18n('fe_es_got_your_back:parts.title4')}
              </Typography>
              <Typography classes={{ root: classes.partDesc }}>
                {i18n('fe_es_got_your_back:parts.desc4')}
              </Typography>
            </Box>
          </Grid>

        </Grid>
        <Box className={classes.getStartedBox}>
          <GetStartedBtn i18n={i18n} />
        </Box>

        <Hidden lgUp>
          <Divider classes={{ root: classes.divider }} />
        </Hidden>
      </Container>
    </>
  );
};

export default GotYourBack;
